@if (preview(); as p) {
  <div class="asset-charge-preview" role="status">
    <p class="asset-charge-preview__row asset-charge-preview__monthly">
      <span class="field__label">{{ 'ASSETS.CHARGE.MONTHLY' | translate }}</span>
      <strong>{{ p.monthlyInstallment }}</strong>
    </p>
    @if (p.monthlySalary !== null && p.monthlySalary !== undefined) {
      <p class="asset-charge-preview__row asset-charge-preview__salary">
        <span class="field__label">{{ 'ASSETS.CHARGE.SALARY' | translate }}</span>
        <strong>{{ p.monthlySalary }}</strong>
      </p>
    }
    @if (p.otherLoanInstallments > 0) {
      <p class="asset-charge-preview__row asset-charge-preview__loans">
        <span class="field__label">{{ 'ASSETS.CHARGE.OTHER_LOANS' | translate }}</span>
        <strong>{{ p.otherLoanInstallments }}</strong>
      </p>
    }
    @if (p.exceedsSalary) {
      <p class="wn-banner wn-banner--warning asset-charge-preview__warn" role="alert">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>{{ 'ASSETS.CHARGE.WARN' | translate }}</span>
      </p>
    }
  </div>
}
